<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-07-05 18:22:39
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 14:04:23
 * @Description: 出借记录
 -->
<template>
  <div>
    <div class="lend-record-wrapper">
      <div class="table-box">
        <div class="table-heard-row">
          <div class="table-col">出借人</div>
          <div class="table-col table-col-center">出借金额(元)</div>
          <div class="table-col">出借时间</div>
        </div>
        <div class="table-row" v-for="(item, index) in lendList" :key="index">
          <div class="table-col">{{ item.lender }}</div>
          <div class="table-col">{{ item.money }}元</div>
          <div class="table-col">{{ item.date }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lend-record',
  data() {
    return {
      lendList: null,
      title: '出借记录'
    };
  },
  created() {
    if (this.$route.params.flag === '1') {
      this.requestRecords();
    } else {
      this.requestNo1Detail();
      return;
    }
  },
  mounted() {
    // this.$eventBus.$emit('listBarTitle', this.title);
  },
  methods: {
    async requestRecords() {
      const res = await this.$http.post('cg/commonRequest', {
        method: 'project.invest.user',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        this.lendNum = res.data.list ? res.data.list.length : 0;
        this.lendList = res.data.list.map(item => {
          return {
            lender: item.mobile,
            money: item.invest_money,
            date: item.invest_time
          };
        });
      }
    },
    // 鲸鱼一号
    async requestNo1Detail() {
      const res = await this.$http.post('/cg/commonRequest', {
        method: 'oproject.detail',
        projectid: this.$route.params.id
      });
      if (res.code === 200) {
        const data = res.data;
        this.lendList = data.investList.map(item => {
          return {
            lender: item.mobile,
            money: item.invest_money,
            date: item.invest_time
          };
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.lend-record-wrapper {
  height: 100%;
  background: #fff;

  .table-box {
    line-height: 1rem;
    font-size: 0.28rem;

    .table-row {
      display: flex;
      justify-content: space-between;
      padding: 0 0.3rem;
      box-sizing: border-box;
      border-top: solid 0.02rem #e8e8e8;
      div:last-child {
        font-size: 0.24rem;
        color: #888888;
      }
    }
    .table-heard-row {
      display: flex;
      justify-content: center;
      padding: 0 0.3rem;
      box-sizing: border-box;
      & > div {
        text-align: center;
        &:last-child {
          width: 2rem;
        }
        &:first-child {
          width: 1.6rem;
        }
      }
      .table-col-center {
        flex: 1;
      }
    }
  }
}
</style>
